import React, { useRef } from "react";
import { Card, Flex } from "antd";
import "./StatsCard.scss";
import HalfDonutPieChart from "../HalfDonutPieChart/HalfDonutPieChart";
import loss from "../../assets/Icons/lossIcon.svg";
import profit from "../../assets/Icons/profitIcon.svg";

const StatsCard = ({
  title,
  value,
  type,
  percent = null,
  amountLabel,
  amount = null,
  chart,
  loading = false,
  info1 = "Telecaller",
  info2 = 'Field Agent',
  footer = true
}) => {
  const chartRef = useRef();

  const handleLegendClick = (index) => {
    chartRef.current?.highlightSlice(index);
  };

  const chartData = [
    { name: "Telecaller", value: 70 },
    { name: "Field Agent", value: 30 },
  ];

  return (
    <Card className="statsCardMain" loading={loading}>
      {type === "default" ? (
        <Card className="stats_Wrapper">
          <Flex className="stats_innerData">
            <Flex className="stats_title">{title}</Flex>
            <Flex className="stats_data">
              <Flex className="number_data">
                <h2>{value}</h2>
              </Flex>
             {
              percent && (
                 <Flex className="plPercentage">
                {(() => {
                  if (parseFloat(percent) > 0) {
                    return (
                      <div className="profit_div">
                        <h2>{percent}</h2>
                        <img src={profit} alt="Profit" />
                      </div>
                    );
                  } else {
                    return (
                      <div className="loss_div">
                        <h2>{percent}</h2>
                        <img src={loss} alt="Loss" />
                      </div>
                    );
                  }
                })()}
              </Flex>
              )
             }
            </Flex>
          </Flex>
       {
        amount && (
             <Flex className="amtDetail">
            <h2 className="desc">{amountLabel}</h2>
            <h2 className="desc_amt">{amount}</h2>
          </Flex>
        )
       }
        </Card>
      ) : (
        <Card className="allocated_Wrapper">
          <Flex vertical className="allocated_content">
            <div className="graph_box">
              <div className="stats_box">
                <div className="allocated_title">{title}</div>
                <div className="allocated_mainData">{value}</div>
              </div>
              <div className="allocated_chart">

                <HalfDonutPieChart
                  data={chart}
                  showValues={true}
                  colors={["#6287FF", "#FF6843"]}
                  formatValue={(v) => `${v}%`}
                  height={58}
                  width={115}
                />
              </div>
            </div>

            {
              footer && (
                <Flex justify="space-between" className="allocated_legend">
              <div
                className="legend_item"
                onClick={() => handleLegendClick(1)}
                style={{ cursor: "pointer" }}
              >
                <span className="dot telecaller"></span> {info1}
              </div>
             {
              info2 && (
                 <div
                className="legend_item"
                onClick={() => handleLegendClick(0)}
                style={{ cursor: "pointer" }}
              >
                <span className="dot fieldAgent"></span> {info2}
              </div>
              )
             }
            </Flex>
              )
            }
          </Flex>
        </Card>
      )}
    </Card>
  );
};

export default StatsCard;
